/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Terms acceptance logic for checkout button
  const checkButtonExists = setInterval(() => {
    const checkoutButton = document.querySelector(
      'button[extra-class="upez-btn--checkout"]'
    );

    if (checkoutButton) {
      clearInterval(checkButtonExists);

      const termsContainer = document.createElement("div");
      termsContainer.className = "upez-terms-container";

      const hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = "attributes[cart.general.accepted_terms]";
      hiddenInput.value = "Yes";

      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.className = "cart__acceptance__input";
      checkbox.name = "acceptance";
      checkbox.id = "acceptance";

      const label = document.createElement("label");
      label.htmlFor = "acceptance";
      label.className = "cart__acceptance__label";
      label.innerHTML = window.theme.strings.upnovaAcceptTerms;

      termsContainer.appendChild(hiddenInput);
      termsContainer.appendChild(checkbox);
      termsContainer.appendChild(label);

      checkoutButton.parentNode.insertBefore(termsContainer, checkoutButton);

      checkoutButton.disabled = true;
      checkbox.addEventListener("change", function () {
        checkoutButton.disabled = !checkbox.checked;
      });
    } else {
  clearInterval(checkButtonExists);
}
  }, 50);

  // function clearDefaultVariantSelection(scope) {
  //   const popoutSelects = scope.querySelectorAll(".select-popout");

  //   const placeholderText =
  //     (window.theme &&
  //       window.theme.strings &&
  //       window.theme.strings.please_select) ||
  //     "Please select";

  //   popoutSelects.forEach((popout) => {
  //     const toggleButton = popout.querySelector(
  //       ".select-popout__toggle span[data-popout-toggle-text]"
  //     );
  //     const addToCartBtn = scope.querySelector('[name="add"]');

  //     // Clear only the visible toggle button text, not the actual hidden input!
  //     if (toggleButton) {
  //       toggleButton.textContent = placeholderText;
  //     }

  //     // Disable Add to Cart button initially
  //     if (addToCartBtn) addToCartBtn.disabled = true;

  //     // Let theme logic handle variant changes when user clicks an option
  //     popout.addEventListener("click", (e) => {
  //       const option = e.target.closest("[data-popout-option]");
  //       if (option) {
  //         // Theme handles updating hidden input, images, sizes, etc.
  //         // Just re-enable Add to Cart
  //         if (addToCartBtn) addToCartBtn.disabled = false;
  //       }
  //     });
  //   });

  //   const form = scope.querySelector('form[action*="/cart/add"]');
  //   if (form) {
  //     form.addEventListener("submit", function (e) {
  //       let valid = true;
  //       popoutSelects.forEach((popout) => {
  //         const hiddenInput = popout.querySelector('input[type="hidden"]');
  //         if (hiddenInput && !hiddenInput.value) {
  //           valid = false;
  //         }
  //       });
  //       if (!valid) {
  //         e.preventDefault();
  //         alert(
  //           (window.theme &&
  //             window.theme.strings &&
  //             window.theme.strings.select_variant_alert) ||
  //             "Please select a variant before adding to cart."
  //         );
  //       }
  //     });
  //   }
  // }

  document.addEventListener("DOMContentLoaded", function () {
    // Clear variant selection on the main product page
    // clearDefaultVariantSelection(document);

    // Use a MutationObserver for Quick Add drawer (loaded dynamically)
    const quickAddObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            node.matches("dialog.product-quick-add[open]")
          ) {
            const contentObserver = new MutationObserver(() => {
              const drawerInner = node.querySelector(
                ".product-quick-add__inner"
              );
              if (drawerInner && drawerInner.children.length > 0) {
                clearDefaultVariantSelection(node);
                contentObserver.disconnect();
              }
            });

            contentObserver.observe(node, {
              childList: true,
              subtree: true,
            });
          }
        });
      });
    });

    quickAddObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });


// function hideUnavailableVariants() {
//   document.querySelectorAll('.radio__button').forEach(button => {
//     button.style.display = '';

//     const input = button.querySelector('input');

//     if (input && (input.classList.contains('sold-out') || input.classList.contains('unavailable'))) {
//       button.style.display = 'none';
//     }
//   });
// }

// document.addEventListener('DOMContentLoaded', hideUnavailableVariants);

// document.addEventListener('theme:variant:change', () => {
//   setTimeout(hideUnavailableVariants, 0);
// });


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
